import { FC } from "react";
import { Link } from "react-router-dom";
import HouseIconSVG from "../../resources/svg/HouseIconSVG";
import DocumentsIconSVG from "../../resources/svg/DocumentsIconSVG";
import HeartIconSVG from "../../resources/svg/HeartIconSVG";
import UserIconSVG from "../../resources/svg/UserIconSVG";
import AccomplishedIconSVG from "../../resources/svg/AccomplishedIconSVG";
import CreateIconSVG from "../../resources/svg/CreateIconSVG";
import SendIconSVG from "../../resources/svg/SendIconSVG";
import SubscribeIconSVG from "../../resources/svg/SubscribeIconSVG";
import { useTranslation } from "react-i18next";

const MobileHeaderBurgerMenuContents: FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <Link
                to="/create-work"
                className="button dmin2:H16B dmax2:H14B dmin2:w-[275px] dmax2:w-[231px] dmin2:h-[50px] dmax2:h-[40px] mb-6 transition duration-300"
            >
                <div className="mb-[2px]">{t("common.createOrder")}</div>
            </Link>
            <Link to="/" className="flex items-center cursor-pointer w-full pb-4 border-b border-b-textFaded group">
                <HouseIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.main")}
                </span>
            </Link>
            <Link
                to="/catalog"
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <DocumentsIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.catalog")}
                </span>
            </Link>
            <Link
                to="/saved"
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <HeartIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.saved")}
                </span>
            </Link>
            <Link
                to="/profile"
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <UserIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.myProfile")}
                </span>
            </Link>
            <Link
                to="#"
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <AccomplishedIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.completedOrders")}
                </span>
            </Link>
            <Link
                to="#"
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <CreateIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.createdOrders")}
                </span>
            </Link>
            <Link
                to="/applications"
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <SendIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.myRequests")}
                </span>
            </Link>
            <Link
                to="/subscription"
                className="flex items-center cursor-pointer w-full mt-[22px] dmax2:mt-[20px] pb-4 border-b border-b-textFaded group"
            >
                <SubscribeIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 mr-3 text-textFaded group-hover:text-textWhite transition duration-300" />
                <span className="H20 dmax2:H16 group-hover:H20B dmax2:group-hover:H16B text-textWhite transition duration-300">
                    {t("common.subscription")}
                </span>
            </Link>
        </>
    );
};

export default MobileHeaderBurgerMenuContents;
